import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  rerunTitle: {
    id: 'course-authoring.course-rerun.title',
    defaultMessage: 'Create a re-run of',
  },
  cancelButton: {
    id: 'course-authoring.course-rerun.actions.button.cancel',
    defaultMessage: 'Cancel',
  },
});

export default messages;
